import React, { useState } from 'react'

const PREMIUM = [
  { ikona: 'cloud', t: 'Prisiminimai debesyje', a: 'Neriboti, saugūs — nedings išvalius naršyklę' },
  { ikona: 'sync', t: 'Sinchronizacija', a: 'Ta pati kelionių istorija visuose įrenginiuose' },
  { ikona: 'route', t: 'Sezoniniai maršrutai', a: 'Paruoštos dienos kelionės ir teminiai rinkiniai' },
  { ikona: 'filter', t: 'Papildomi filtrai', a: 'Filtruok pagal nuotaiką, sezoną, kainą' },
  { ikona: 'heart', t: 'Palaikai kūrėją', a: 'Padedi Klajok augti be reklamų' },
]

const IK = {
  cloud: <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />,
  sync: <><path d="M23 4v6h-6M1 20v-6h6" /><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" /></>,
  route: <><circle cx="6" cy="19" r="3" /><circle cx="18" cy="5" r="3" /><path d="M9 19h6a3 3 0 0 0 3-3V8" /></>,
  filter: <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />,
  heart: <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z" />,
}

const NORU_RAKTAS = 'premium_noras'

function PrenumerataEkranas({ atidaryta, onClose, onToast }) {
  const [noretas, setNoretas] = useState(() => {
    try { return localStorage.getItem(NORU_RAKTAS) === '1' } catch { return false }
  })

  function pranesti() {
    try { localStorage.setItem(NORU_RAKTAS, '1') } catch {}
    setNoretas(true)
    if (onToast) onToast('Ačiū! Pranešime, kai Premium bus paruoštas')
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#141F1A', zIndex: 1001, transform: atidaryta ? 'translateX(0)' : 'translateX(100%)', transition: 'transform 340ms cubic-bezier(0.32,0.72,0,1)', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 'calc(14px + env(safe-area-inset-top)) 16px 8px', flexShrink: 0 }}>
        <button onClick={onClose} aria-label="Atgal" style={{ width: 34, height: 34, borderRadius: '50%', border: '1px solid #3A4C42', background: 'transparent', color: '#F0E8D5', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <span style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: 19 }}>Prenumerata</span>
        <div style={{ width: 34 }} />
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '8px 16px calc(28px + env(safe-area-inset-bottom))' }}>
        <div style={{ textAlign: 'center', padding: '10px 0 20px' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: 'rgba(229,168,64,0.14)', border: '1px solid rgba(229,168,64,0.35)', color: '#E5A840', fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase', padding: '5px 12px', borderRadius: 999, marginBottom: 14 }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="#E5A840" stroke="none"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z" /></svg>
            Premium
          </div>
          <h1 style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: 26, fontWeight: 500, margin: 0, lineHeight: 1.15 }}>Daugiau iš tavo kelionių</h1>
          <p style={{ color: '#B0B8A8', fontSize: 13.5, lineHeight: 1.55, margin: '10px 20px 0' }}>Nemokama versija visada liks. Premium — tiems, kas nori daugiau ir nori paremti projektą.</p>
        </div>

        <div style={{ background: '#1E2E27', border: '1px solid rgba(229,168,64,0.35)', borderRadius: 16, padding: '16px 18px', marginBottom: 16 }}>
          {PREMIUM.map((p, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: i === PREMIUM.length - 1 ? 0 : 14 }}>
              <div style={{ width: 36, height: 36, borderRadius: '50%', flexShrink: 0, background: 'rgba(229,168,64,0.14)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E5A840" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">{IK[p.ikona]}</svg>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ color: '#F0E8D5', fontSize: 14 }}>{p.t}</div>
                <div style={{ color: '#7A8A7E', fontSize: 12, marginTop: 2, lineHeight: 1.4 }}>{p.a}</div>
              </div>
            </div>
          ))}
        </div>

        {noretas ? (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, height: 52, borderRadius: 12, background: 'rgba(127,179,105,0.12)', border: '1px solid rgba(127,179,105,0.4)', color: '#7FB369', fontFamily: 'Syne, system-ui, sans-serif', fontSize: 14 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7FB369" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
            Esi sąraše — pranešime pirmiesiems
          </div>
        ) : (
          <button onClick={pranesti} style={{ width: '100%', height: 54, borderRadius: 12, background: '#E5A840', color: '#141F1A', border: 'none', fontFamily: "'Lora', Georgia, serif", fontSize: 17, fontWeight: 600, cursor: 'pointer' }}>
            Pranešti, kai bus
          </button>
        )}
        <p style={{ color: '#5A6558', fontSize: 11, textAlign: 'center', marginTop: 12 }}>Kaina ir paleidimo data — netrukus. Jokių įsipareigojimų.</p>
      </div>
    </div>
  )
}

export default PrenumerataEkranas
